import flippboardTile from './flippboardTile.svg';
import flowerTile from './flowerTile.svg';
import parentChildReadingTile from './parentChildReadingTile.svg';
import resumeTile from './resumeTile.svg';
import talkingTile from './talkingTile.svg';

export const tileImages = {
  flippboardTile,
  flowerTile,
  parentChildReadingTile,
  resumeTile,
  talkingTile,
};
